export const cents = value => Math.round(Number(value || 0) * 100);
export const moneyText = value => (value / 100).toFixed(2);

export function cpfError(cpf, mode) {
  if (!cpf) return mode === 'entrega' ? 'CPF do destinatário é obrigatório para pedidos de entrega.' : '';
  const invalid = 'CPF inválido. Confira os 11 dígitos.';
  if (!/^[0-9]{11}$/.test(cpf) || new Set(cpf).size === 1) return invalid;
  for (const size of [9, 10]) {
    const sum = [...cpf.slice(0, size)].reduce((total, digit, index) => total + Number(digit) * (size + 1 - index), 0);
    if (((sum * 10) % 11) % 10 !== Number(cpf[size])) return invalid;
  }
  return '';
}

export function newestOrder(current, incoming) {
  return current?.versao > incoming.versao ? current : { ...current, ...incoming };
}

export function cartLines(cart, observations = {}) {
  return cart.map(item => {
    const flavors = typeof item.id === "string" && /^half-\d+-\d+$/.test(item.id)
      ? item.id.split("-").slice(1).map(Number) : [Number(item.id)];
    return {
      produto_id: flavors[0], quantidade: item.qty,
      ...(flavors.length === 2 ? { segundo_sabor_id: flavors[1] } : {}),
      observacoes: observations[item.id]?.trim() || item.observacoes || "",
    };
  });
}

export const PAYMENT_METHODS = {
  "Dinheiro": "dinheiro", "PIX": "pix_estatico", "Pix": "pix_estatico",
  "Cartão de Crédito": "credito", "Cartão de Débito": "debito",
  "Crédito": "credito", "Débito": "debito", "Cartão": null,
};

export function singlePayment(label, total, cashReceived = "") {
  const method = PAYMENT_METHODS[label];
  if (!method) return null;
  const value = method === "dinheiro" && cashReceived ? Math.max(cents(total), cents(cashReceived)) : cents(total);
  return [{ metodo: method, valor: moneyText(value), confirmado: false }];
}
